export default __webpack_public_path__ + "static/media/logo-BPO.ebc4c9e0.png";